import PageLayout from "components/PageLayout";

const TermsAndConditions = () => {
  return (
    <PageLayout pageTitle={"Terms And Conditions of Use"}>
      <p>
        The calculations provided on this webpage estimate the thermal balance point 
        and potential heat pump utilization by analyzing historical gas consumption data. 
        <b>The calculations involve an estimate of the average heat loss of the home relative 
        to outdoor temperatures. This is not the same as calculating the design heat loss 
        of the home. Design heat loss must be determined in accordance with the CSA F280-12 
        standard.</b> Consequently, while the calculations may offer some insight into backup or 
        supplemental heating system sizing, they do not provide sufficient information to be 
        used as the sole basis for backup or supplemental system sizing in outdoor design 
        conditions. Users should independently verify all results and should not rely solely 
        on the calculations for critical decision-making without professional consultation.
      </p>
      <p>
        The calculations on this webpage are for informational purposes only and are intended to 
        offer general guidance. While we strive to ensure the accuracy of the calculations, we 
        do not guarantee the results or their applicability to specific homes or situations. The 
        responsibility for correctly sizing and selecting heating and cooling equipment lies solely 
        with the HVAC contractor or mechanical designer. The results generated by this tool should 
        be independently verified by a qualified professional. Toronto and Region Conservation 
        Authority (“TRCA”) assumes no liability for any direct or indirect consequences arising from 
        the use or reliance on the information provided by this tool. This software is provided in an 
        “AS IS” basis. TRCA shall not be liable for loss or damage arising out of the installation, 
        use or uninstallation of the software. TRCA disclaims all warranties, either express or implied. 
        TRCA makes no warranties, expressed or implied, and hereby disclaims and negates all other 
        warranties, including without limitation, implied warranties or conditions of merchantability, 
        fitness for a particular purpose, or non-infringement of intellectual property or other violation 
        of rights. Further, TRCA does not warrant or make any representations concerning the accuracy, 
        likely results, or reliability of the use of the tool or otherwise relating to such materials or 
        on any sites linked to this tool.
      </p>
      <p>
        In no event shall TRCA be liable for any damages (including, without limitation, damages for loss 
        of data or profit, or due to business interruption), arising out of the use or inability to use this 
        tool, even if TRCA or a TRCA authorized representative has been notified orally or in writing of the 
        possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, 
        or limitations of liability for consequential or incidental damages, these limitations may not apply to you.
      </p>
      <p>
      Any use of trade or product names does not imply endorsement or recommendation of those products. 
      This work is protected under Canadian copyright law and other international copyright treaties and 
      conventions. No part of this work may be reproduced or transmitted for commercial purposes, in any 
      form or by any means, electronic or mechanical, including photocopying and recording, or by any 
      information storage or retrieval system, except as expressly permitted in writing by Sustainable 
      Technologies Evaluation Program (STEP).
      </p>
      <p>
      Toronto and Region Conservation Authority may revise these terms of use for the tool at any time 
      without notice. By using this tool, you agree to be bound by these Terms and Conditions of Use.
      </p>
    </PageLayout>
  );
};

export default TermsAndConditions;
